module.exports = __webpack_public_path__ + "img/list_thumbnail_01.310bdd3a.jpg";